import {
  BrowserRouter,
  Route,
  Routes,
  useNavigate,
  useParams,
} from "react-router-dom";
import "./App.css";
import Footer from "./Components/Footer";
import { useEffect, useState } from "react";
import Data from "./Data/Data";
import Element from "./Components/Element";
import Controls from "./Components/Controls";
import Header from "./Components/Header";
import Menu from "./Components/Menu";
import { Helmet } from "react-helmet";
import ScrollToTop from "./ScrollToTop";

function App() {
  return (
    <>
      <BrowserRouter basename="/historia">
      <ScrollToTop />
        <Routes>
          <Route path="/:element" element={<RouteResolver />} />
          <Route path="/" element={<Menu />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

const RouteResolver = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [elemIdx, setElemIdx] = useState({});

  useEffect(() => {
    if (params.element) {
      const elemId = Data.findIndex((e) => e.url === params.element) || Data.findIndex((e) => encodeURIComponent(e.url) === params.element);
      if (elemId !== -1) {
        setElemIdx(elemId);
      } else navigate("/");
    }
  }, [params, navigate]);

  const onNext = () =>{
    navigate(`/${Data[(elemIdx +1)%Data.length].url}`)
  }
  const onPrevious = () =>{
    navigate(`/${Data[(elemIdx + Data.length -1)%Data.length].url}`)
  }
  return (
    <>
      <Helmet>
        <title>Hacienda de los Morales - {Data[elemIdx] ? toTitleCase(Data[elemIdx].name) : ""}</title>
      </Helmet>
      <Header />
      <Element element={Data[elemIdx]} />
      <Controls next={onNext} previous={onPrevious}/>
      <Footer />
    </>
  );
};

function toTitleCase(str) {
  const titleCase = str
    .toLowerCase()
    .split(' ')
    .map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');

  return titleCase;
}

export default App;
